export const ROUTE_MAP = {
  home: "/",
  ad: {
    taskList: "/ad-tasks",
    taskDetail: "/ad-tasks/detail",
    taskDetailV2: "/ad-tasks/detail-v2",
    recommended: "/ad-tasks/recommended",
  },
  order: {
    payment: "/order-payment",
    paymentResult: "/order-payment-result",
  },
  activity: {
    midyearSale: "/activity/midyear-sale",
    bf2025: {
      gmv: "/activity/bf2025/gmv",
      gmvRules: "/activity/bf2025/gmv/rules",
      ad: "/activity/bf2025/ad",
      adRules: "/activity/bf2025/ad/rules",
    },
  },
  ai: {
    scriptExtract: "/script-extract",
    myScripts: "/my-scripts",
    rewrite: "/rewrite",
    rewriteScript: "/rewrite-script",
    scriptInfo: "/script-info",
  },
  product: {
    list: "/products",
    detail: "",
  },
  doc: {
    tutorial: "/tutorial",
  },
  message: {
    list: "/message",
    detail: "/message/detail",
  },
  bf2025Ai: {
    rules: "/activity/bf2025/ai/rules",
  },
  2025: {
    christmas: {
      holidayHaul: "/activity/2025/christmas/holiday-haul",
      holidayHaulList: "/activity/2025/christmas/holiday-haul/list",
      glowUp: "/activity/2025/christmas/glow-up",
      glowUpList: "/activity/2025/christmas/glow-up/list",
      gift: "/activity/2025/christmas/gift",
      giftList: "/activity/2025/christmas/gift/list",
      gmv: "/activity/2025/christmas/gmv",
      gmvRules: "/activity/2025/christmas/gmv/rules",
      taskCenter: "/activity/2025/christmas/task-center",
    },
  },
};
